import Item from "./Item";

export default class ItemBlockPart {
  constructor(
    public id: number,
    public item: Item,
    public quantity: number,
  ) {}
}
